import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}

function getStartingLocale() {
  const savedLocale = localStorage.getItem('lang');
  if (savedLocale) return savedLocale;

  const browserLang = navigator.language.split('-')[0];
  const supportedLocales = ['es', 'en'];
  return supportedLocales.includes(browserLang) ? browserLang : 'es';
}

export default createI18n({
  legacy: false,
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
});
